import { Turbo } from "@hotwired/turbo-rails"

const I18N = {
  "pt-BR": { confirm: "Confirmar", cancel: "Cancelar" },
  pt:      { confirm: "Confirmar", cancel: "Cancelar" },
  en:      { confirm: "Confirm",   cancel: "Cancel" },
  es:      { confirm: "Confirmar", cancel: "Cancelar" }
}

function labels () {
  const language = (document.documentElement.lang || "pt-BR").toLowerCase()
  const key  = Object.keys(I18N).find(locale => language.startsWith(locale.toLowerCase()))
  return I18N[key] || I18N["pt-BR"]
}

function openConfirm (message) {
  return new Promise(resolve => {
    const { confirm: confirmLabel, cancel: cancelLabel } = labels()

    const overlay = document.createElement("div")
    overlay.className = "gimmo-confirm-overlay"
    overlay.setAttribute("role", "dialog")
    overlay.setAttribute("aria-modal", "true")

    const dialog = document.createElement("div")
    dialog.className = "gimmo-confirm-dialog"
    overlay.appendChild(dialog)

    const text = document.createElement("p")
    text.className = "gimmo-confirm-text"
    text.textContent = message
    dialog.appendChild(text)

    const actions = document.createElement("div")
    actions.className = "gimmo-confirm-actions"
    dialog.appendChild(actions)

    const cancelButton = document.createElement("button")
    cancelButton.type = "button"
    cancelButton.className = "gimmo-confirm-cancel"
    cancelButton.textContent = cancelLabel
    actions.appendChild(cancelButton)

    const confirmButton = document.createElement("button")
    confirmButton.type = "button"
    confirmButton.className = "gimmo-confirm-accept"
    confirmButton.textContent = confirmLabel
    actions.appendChild(confirmButton)

    const previouslyFocused = document.activeElement
    const close = (result) => {
      document.removeEventListener("keydown", onKey)
      overlay.remove()
      if (previouslyFocused && typeof previouslyFocused.focus === "function") {
        previouslyFocused.focus()
      }
      resolve(result)
    }

    const onKey = (event) => {
      if (event.key === "Escape") { event.preventDefault(); close(false) }
      if (event.key === "Enter")  { event.preventDefault(); close(true) }
    }

    overlay.addEventListener("click", (event) => { if (event.target === overlay) close(false) })
    cancelButton.addEventListener("click", () => close(false))
    confirmButton.addEventListener("click", () => close(true))
    document.addEventListener("keydown", onKey)

    document.body.appendChild(overlay)
    requestAnimationFrame(() => overlay.classList.add("is-open"))
    confirmButton.focus()
  })
}

if (Turbo?.config?.forms) {
  Turbo.config.forms.confirm = openConfirm
} else if (typeof Turbo?.setConfirmMethod === "function") {
  Turbo.setConfirmMethod(openConfirm)
}
